import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { isPaypalSettingsOpened } from 'client/reducers/managementReducer'
import { useManagement } from 'client/store'
import { PaypalPreviewButton } from 'common/components/entities/paypal-rest-button/preview-button'
import React from 'react'
import { useCalculateButtonStyles } from 'src/editor/shared/hooks/use-calculate-button-styles'
import { useSelectedButtonColor } from 'src/editor/shared/hooks/use-theme-color/use-selected-button-color'
import { Button } from 'src/shared/components/button/button'
import { PaymentButtonEntityInterface } from 'src/shared/entities/payment-button/payment-button.schema'
import { EntityIdType } from 'src/shared/schemas/entity-id.schema'
import { WebsiteSettingsTypographyTypeEnum } from 'src/shared/types/website-settings-types'

export interface PaymentButtonProps {
  entity: PaymentButtonEntityInterface
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
  isRemoveAllowed: boolean
  isSaveAllowed: boolean
  isCopyAllowed: boolean
  dropBoxAllowedEntityIds?: EntityIdType[]
}

const PaymentButtonNew = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
  isRemoveAllowed,
  isSaveAllowed,
  isCopyAllowed,
  dropBoxAllowedEntityIds,
}: PaymentButtonProps) => {
  const showPaypalSettings = useManagement(isPaypalSettingsOpened)

  const {
    calculatedBorder,
    calculatedPadding,
    calculatedFontSize,
    calculatedLineHeight,
    // calculatedTextAlign,
    // calculatedLetterSpacing,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useCalculateButtonStyles({
    border: entity.border,
    mobileBorder: entity.mobileBorder,
    padding: entity.padding,
    mobilePadding: entity.mobilePadding,
    buttonType:
      entity.buttonType || WebsiteSettingsTypographyTypeEnum.PrimaryButton,
    fontSize: entity.textFontSize,
    mobileFontSize: entity.mobileTextFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    fontFamily: entity.textFontFamily,
    mobileFontFamily: entity.mobileTextFontFamily,
    fontWeight: entity.textFontWeight,
    mobileFontWeight: entity.mobileTextFontWeight,
    fontStyle: entity.textFontStyle,
    mobileFontStyle: entity.mobileTextFontStyle,
  })
  const {
    buttonTextColor,
    buttonBackgroundColor,
    hoveredButtonBackgroundColor,
  } = useSelectedButtonColor(
    entity.buttonType || WebsiteSettingsTypographyTypeEnum.PrimaryButton,
  )

  return (
    <BaseEntityNew
      entity={entity}
      flex
      flexColumn
      isMoveUpAllowed={isMoveUpAllowed}
      isMoveDownAllowed={isMoveDownAllowed}
      isRemoveAllowed={isRemoveAllowed}
      isSaveAllowed={isSaveAllowed}
      isCopyAllowed={isCopyAllowed}
      dropBoxAllowedEntityIds={dropBoxAllowedEntityIds}
    >
      {showPaypalSettings ? (
        <PaypalPreviewButton type={entity.paypal?.backgroundColor} />
      ) : (
        <Button
          attrId={entity.htmlAttrId}
          text={entity.text}
          subText={entity.subText}
          width={entity.width}
          mobileWidth={entity.mobileWidth}
          padding={calculatedPadding.desktop}
          mobilePadding={calculatedPadding.mobile}
          border={calculatedBorder.desktop}
          mobileBorder={calculatedBorder.mobile}
          alignSelf={entity.alignSelf}
          mobileAlignSelf={entity.mobileAlignSelf}
          textColor={entity.textColor || buttonTextColor}
          mobileTextColor={entity.mobileTextColor || buttonTextColor}
          textFontSize={calculatedFontSize.desktop}
          mobileTextFontSize={calculatedFontSize.mobile}
          lineHeight={calculatedLineHeight.desktop}
          mobileLineHeight={calculatedLineHeight.mobile}
          textFontFamily={calculatedFontFamily.desktop}
          textFontStyle={calculatedFontStyle.desktop}
          textFontWeight={calculatedFontWeight.desktop}
          subTextFontSize={entity.subTextFontSize}
          mobileSubTextFontSize={entity.mobileSubTextFontSize}
          subTextColor={entity.subTextColor}
          mobileSubTextColor={entity.mobileSubTextColor}
          subTextFontFamily={entity.subTextFontFamily}
          subTextFontStyle={entity.subTextFontStyle}
          subTextFontWeight={entity.subTextFontWeight}
          boxShadow={entity.boxShadow}
          mobileBoxShadow={entity.mobileBoxShadow}
          hover={{
            ...entity.hover,
            backgroundColor:
              entity?.hover?.backgroundColor || hoveredButtonBackgroundColor,
          }}
          mobileHover={{
            ...entity.mobileHover,
            backgroundColor:
              entity?.mobileHover?.backgroundColor ||
              entity?.hover?.backgroundColor ||
              hoveredButtonBackgroundColor,
          }}
          background={
            (entity.background ?? entity.backgroundColor) ||
            buttonBackgroundColor
          }
          mobileBackground={
            (entity.mobileBackground ?? entity.mobileBackgroundColor) ||
            buttonBackgroundColor
          }
          iconClassNameBefore={entity.iconClassNameBefore}
          iconClassNameAfter={entity.iconClassNameAfter}
        />
      )}
    </BaseEntityNew>
  )
}
export default PaymentButtonNew
